import { useDashboardContext } from './DashboardContext';

export const usePageLocation = () => {
  return useDashboardContext()?.location;
};
